import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, NgZone, OnDestroy, OnInit} from '@angular/core';
import {CountdownResult, CountdownService} from '@core/services/countdown.service';
import {TruckIconComponent} from '@core/svg-icons/truck-icon.component';


@Component({
  selector: 'app-product-delivery-countdown',
  templateUrl: './product-delivery-countdown.component.html',
  styleUrls: ['./product-delivery-countdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TruckIconComponent
  ]
})
export class ProductDeliveryCountdownComponent implements OnInit, OnDestroy {
  protected changeDetector = inject(ChangeDetectorRef);
  protected countdownService = inject(CountdownService);
  protected ngZone = inject(NgZone);


  hours: number;
  minutes: number;
  distance: number;
  now: number;

  target: Date;

  constructor() {
    this.target = new Date(new Date().setHours(15, 30, 0))
    this.callback(this.countdownService.calculateDistance(this.target), false);
  }

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.countdownService.addCountdown('countdown-order', {
        target: this.target,
        callback: result => {
          this.callback(result, true);
        }
      })
    })
  }

  protected callback(result: CountdownResult, detectChanges: boolean) {
    const hoursDiff = result.hours !== this.hours;
    const minutesDiff = result.minutes !== this.minutes;
    this.distance = result.distance;
    this.hours = result.hours;
    this.minutes = result.minutes;
    if ((hoursDiff || minutesDiff) && detectChanges) {
      this.changeDetector.detectChanges();
    }
  }

  // on destroy - clear if not cleared or is set
  ngOnDestroy() {
    this.countdownService.removeCountdown('countdown-order');
  }
}


